var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[[_c('app-header',{attrs:{"records":_vm.records},on:{"getfiltes":function($event){return _vm.getReports()}}})],_c('router-view'),_c('app-footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }